import ProductListNew from "../screens/lcaProduct/productList/ProductListNew";
import ProductList from "../screens/product/productList/ProductList";
import { ENABLE_LCA_PRODUCT_UI_REDESIGN } from "../config/constants";
import { adminAccess, supplierAccess, userAccess } from "./useRoleAccess";

const ProductGrid = ENABLE_LCA_PRODUCT_UI_REDESIGN ? <ProductListNew /> : <ProductList />;

export const ProductRoutes = [
  {
    path: "/product",
    route: ProductGrid,
    protectRoutes: true,
    roleGrantAccess: [...adminAccess, ...userAccess, ...supplierAccess]
  }
];
